exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sidebar--3QPwf {\n  background-color: #3b5032;\n  flex-direction: column;\n  align-items: center;\n  overflow: hidden;\n  transition: all 0.2s ease;\n}\n\n.sidebar--3QPwf.shrink--1J7oM {\n  width: 0;\n  flex-basis: 0;\n}\n\n.sidebar--3QPwf hr {\n  width: 100%;\n  border-color: #eaeaea;\n}\n\n.sidebar--3QPwf a {\n  color: #fff;\n}\n\n", ""]);

// exports
exports.locals = {
	"sidebar": "sidebar--3QPwf",
	"shrink": "shrink--1J7oM"
};